// Admin-side helpers for reading customer messages out of a claim's activity
// history. The "have I seen this?" state now lives in the notification
// infrastructure (server-side, per-user) - see use-notifications - so this file
// only parses the history to find the latest consumer message (e.g. to open it
// from a Spotlight attention banner).

interface ClaimHistoryEntryLike {
  created_at: string
  action_key: string
  parameters: Record<string, unknown> | null
}

function toTimestamp(value: string | null | undefined) {
  if (!value) return null
  const parsed = Date.parse(value)
  return Number.isNaN(parsed) ? null : parsed
}

function isConsumerMessage(entry: ClaimHistoryEntryLike) {
  const params = entry.parameters
  if (!params) return false

  const senderRole = params.sender_role
  const isInternal = params.is_internal
  const message = params.message

  return (
    typeof message === 'string'
    && message.trim().length > 0
    && isInternal !== true
    && senderRole === 'consumer'
    && (entry.action_key === 'consumer_contact' || entry.action_key === 'note')
  )
}

export function getLatestConsumerMessageEntry<T extends ClaimHistoryEntryLike>(
  history: T[],
): T | null {
  const incoming = history.filter(isConsumerMessage)
  return (
    incoming.sort(
      (a, b) => (toTimestamp(b.created_at) ?? 0) - (toTimestamp(a.created_at) ?? 0),
    )[0] ?? null
  )
}
